import { observer } from 'mobx-react-lite'
import { capitalize } from 'lodash'
import React, { useEffect, useState } from 'react'
import { Box, Button, Icon, TextFieldWithLabel, Typography } from 'shared/ui'
import { makeTextFieldAutoFocus } from 'shared/ui/TextField'
import { ReviewAccount } from 'entities/Review/model/ReviewAccount'
import { type ReviewAccountsStore } from 'pages/reviews/ui/ReviewAccounts'
import styles from './styles.module.scss'

type IReviewAccountContentProps = {
  store: ReviewAccountsStore
}

export const ReviewAccountContent = observer(({ store }: IReviewAccountContentProps) => {
  const { editedAccount, errorsMap, removeError, onClose, onSaveLink, loading } = store
  const [draft] = useState(() => new ReviewAccount(editedAccount?.params))
  const { name, icon, type, url, setUrl, buttonName, setButtonName } = draft
  const isEditMode = !!editedAccount?.url.length

  useEffect(() => {
    if (!buttonName) setButtonName(name)
  }, [])

  if (!editedAccount) return null

  return (
    <Box display={'flex'} flexDirection={'column'} gap={'24px'}>
      <Box display={'flex'} alignItems={'center'} gap={'8px'}>
        <div>
          <Icon icon={icon} fontSize={20} />
        </div>
        <Typography variant={'heading-md'} ariaLabel={'accountName'} ellipsis>
          {name}
        </Typography>
      </Box>

      <TextFieldWithLabel
        labelProps={{
          label: {
            text: `Your ${type === 'custom' ? type : capitalize(type)} review URL`,
            textColor: 'var(--content-primary-tertiary)',
            textClassName: styles.reviewsLabel,
          },
        }}
        textFieldProps={{
          value: url,
          onChange: (value) => {
            setUrl(value)
            removeError('url_link')
          },
          InputProps: {
            placeholder: 'https://example.com/',
          },
          mainActions: [makeTextFieldAutoFocus({ withFocus: true })],
        }}
        errorMessage={errorsMap.get('url_link')}
      />

      <TextFieldWithLabel
        labelProps={{
          label: {
            text: 'Button name',
            textColor: 'var(--content-primary-tertiary)',
            textClassName: styles.reviewsLabel,
          },
        }}
        textFieldProps={{
          value: buttonName,
          onChange: (value) => {
            setButtonName(value)
            removeError('button_name')
          },
          InputProps: {
            placeholder: 'Enter button name',
          },
        }}
        limit={50}
        errorMessage={errorsMap.get('button_name')}
      />

      <Box display={'flex'} alignItems={'center'} justifyContent={'flex-end'} gap={'8px'}>
        <Button
          text='Cancel'
          typeBtn='contained'
          contained='secondary'
          size='medium'
          onClick={onClose}
        />
        <Button
          text='Save'
          typeBtn='contained'
          contained='primary'
          size='medium'
          loading={loading}
          onClick={() => {
            void onSaveLink(draft, isEditMode)
          }}
        />
      </Box>
    </Box>
  )
})
